import { useWorkspace } from "@/components/helpers/custom-hooks/use-workspace";
import { Tooltip } from "@/components/helpers/ui/blueprint-overrides/Tooltip";
import { Box, Flex } from "@/components/layout/flexbox";
import { Avatar } from "@/components/pieces/users/Avatar";
import { getUser } from "@/components/session/JwtTokenManager";
import { MIDTEXT_COLOR } from "@/css/constants";

const titleCss = {
  fontSize: 14,
  fontWeight: 600,
  lineHeight: "14px",
};

export function RoleplayOwnership() {
  const user = getUser();
  const workspace = useWorkspace();
  const isPersonalMode = !workspace;

  if (!user) return "Please Login";

  return (
    <>
      <Box fontWeight={600} fontSize={16}>
        Owner
      </Box>
      <Box mt={1}>
        <Box css={{ display: "flex", alignItems: "center", gap: 12 }}>
          <Tooltip content={user.name || user.email}>
            <Avatar user={user} size={36} />
          </Tooltip>
          <Flex style={{ gap: 4 }} flexDirection={"column"}>
            {user.name && (
              <Box css={titleCss} lineHeight={"14px"}>
                {user.name}
              </Box>
            )}
            <Box fontSize={12} color={MIDTEXT_COLOR} lineHeight={"12px"}>
              {user.email}
            </Box>
          </Flex>
        </Box>
      </Box>
      {!isPersonalMode && (
        <Box mt={3}>
          <Box fontWeight={600} fontSize={16}>
            Workspace
          </Box>
          <Box css={titleCss} lineHeight={"14px"} mt={1}>
            {workspace?.name}
          </Box>
        </Box>
      )}
    </>
  );
}
